export const trackConversion = (value, transactionId = '') => {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17005273287/hm54CP_32oEcEMfB36w_',
      value: value,
      currency: 'USD',
      transaction_id: transactionId
      // 'new_customer': true /* calculate dynamically, populate with true/false */,
    });
  }
};